import { API } from "./API"

const createLead = (data) => {
    return API.post('leads', data)
}

export {
    createLead
};
  